import { NextPage } from 'next'
import { ELanguage } from '@microfrontends/react-components'
import MainLayout from '../../containers/MainLayout'
import IPageProps from '../../services/models'
import JobSearchContainer from '../../containers/JobSearchContainer'
import { ISSRJobSearchProps, getServerSideProps } from '../../ssr/jobSearch'
import { EPages } from '@microfrontends/app-shell-v2'
import { convertMetaInfo } from '../../util/convertMetaInfo'

const JobSearchPage: NextPage<IPageProps & ISSRJobSearchProps> = (props) => {
	const { metaData, ...rest } = props
	return (
		<MainLayout
			{...rest}
			t={() => ''}
			languageCode={ELanguage.EN}
			pageName={EPages.SEO_LANDING_PAGE}
			metaKeywords='recruitment, employment, job search, quick job search, job search, job search 24h'
			metaTitle={
				convertMetaInfo(metaData?.title) ||
				'Recruitment latest, quickly job 24 hours at Vietnamworks'
			}
			metaDescription={
				convertMetaInfo(metaData?.description) ||
				'Recruitment the quick jobs nationwide with high, attractive salaries and good benefits. Find a job quickly 24h at Vietnamworks.'
			}
			metaCanonical={metaData?.canonicalUrl || 'tim-viec-lam'}
			noIndex
			responsiveCornerColor='#F4F4F7'
		>
			<JobSearchContainer langCode={ELanguage.EN} {...props} />
		</MainLayout>
	)
}
export default JobSearchPage
export { getServerSideProps }
